export default {
	vipBenefits: {
		salaryTitle: 'Salário VIP',
		benefitsTitle: 'Benefícios',
		yourVipProgress: 'Seu Progresso VIP',
		progressToVip: '{percent}% até VIP {level}',
		vipMax: 'Nível Máximo Alcançado',
		vipLevelBenefits: 'Nível e Benefícios VIP',
		betXpRule: 'Aposte {amount} = {xp}EXP',
		btnReceive: 'Receber',
		btnJoinIn: 'Participar',
		btnReceived: 'Recebido',
		btnExpired: 'Expirado',
		btnNotSettled: 'Não Liquidado',
		btnComingSoon: 'Em Breve',
		btnViewMore: 'Ver Mais',
		btnContactNow: 'Contatar',
		guestTitleLevelup: 'Bônus de Subida de Nível',
		guestTitleDaily: 'Salário Diário',
		guestTitleWeekly: 'Salário Semanal',
		guestTitleMonthly: 'Salário Mensal',
		guestTitleCashback: 'Reembolso',
		guestTitleRescue: 'Bônus de Resgate',
		guestTitleEvents: 'Eventos VIP',
		guestTitleSupport: 'Suporte VIP',
		guestDescLevelup: 'Receba um bônus único sempre que atingir um novo nível VIP.',
		guestDescDaily: 'Resgate uma recompensa de salário diário conforme seu nível VIP cresce.',
		guestDescWeekly: 'Resgate uma recompensa de salário semanal conforme seu nível VIP cresce.',
		guestDescMonthly: 'Resgate uma recompensa de salário mensal conforme seu nível VIP cresce.',
		guestDescCashback: 'Ganhe reembolso sobre seus gastos em jogos.',
		guestDescRescue: 'Receba um bônus de resgate para ajudá-lo a se recuperar.',
		guestDescEvents: 'Níveis VIP mais altos desbloqueiam mais recompensas de eventos exclusivos.',
		guestDescSupport: 'Suporte VIP dedicado para assistência mais rápida.',
		comingSoonHint: 'Benefício em breve, fique atento',
		receiveSuccess: 'Recompensa recebida',
		receiveFailed: 'Falha ao receber recompensa',
		typeUpgrade: 'Bônus de Subida de Nível',
		typeDailySalary: 'Salário Diário',
		typeWeeklySalary: 'Salário Semanal',
		typeMonthlySalary: 'Salário Mensal',
		typeRebate: 'Cashback',
		typeRescue: 'Bônus de Resgate',
		typeVipActivity: 'Eventos VIP',
		typeVipService: 'Suporte VIP',
		tooltipRecharge: 'Recarga {current}/{target}',
		tooltipBets: 'Apostas {current}/{target}',
		progressRecharge: 'Recarga',
		progressBets: 'Apostas',
		descUpgradeBonus: 'Bônus de Upgrade VIP{level} ×{count}',
		descDailySalary: 'Salário Diário VIP{level} ×{count}',
		descWeeklySalary: 'Salário Semanal VIP{level} ×{count}',
		descMonthlySalary: 'Salário Mensal VIP{level} ×{count}',
		descUpgradeBonusPlain: 'Bônus de Upgrade VIP{level}',
		descDailySalaryPlain: 'Salário Diário VIP{level}',
		descWeeklySalaryPlain: 'Salário Semanal VIP{level}',
		descMonthlySalaryPlain: 'Salário Mensal VIP{level}',
		descRebate: 'Reembolso de Jogos VIP{level}',
		descRescue: 'Bônus de Resgate VIP{level}',
		descVipActivity: 'Níveis VIP mais altos desbloqueiam mais recompensas de eventos exclusivos.',
		descVipService: 'Suporte VIP dedicado para assistência mais rápida.',
		allBenefits: 'Todos os Benefícios',
		vipClubTitle: 'VIP Club',
		more: 'Mais',
		moreDesc: 'Consulte nossas promoções para mais detalhes.',
		promotions: 'Promoções',
		highlightsTitle: '8 Destaques do Programa',
		highlightSupport: 'Suporte VIP Exclusivo',
		highlightLevelup: 'Bônus de Subida de Nível',
		highlightSalary: 'Salário VIP',
		highlightRescue: 'Bônus de Resgate VIP',
		highlightGifts: 'Presentes\nExclusivos VIP',
		highlightEvents: 'Eventos VIP',
		highlightService: 'Atendimento\nVIP Dedicado',
		highlightWallet: 'Carteira\nde Crédito VIP',
		currentLevel: 'Nível Atual',
		keepPlayingReach: 'Continue jogando para alcançar',
		higherLevelRewards: 'Quanto maior o nível, maiores as recompensas',
		levelUpUnlock: 'Suba de nível para desbloquear benefícios exclusivos e desfrutar de uma experiência premium.',
		yourVipBenefits: 'Seus Benefícios VIP',
		viewVipLevels: 'Ver Níveis VIP',
		exclusiveBenefitsTitle: 'Seus Benefícios Exclusivos',
		tipExclusiveRewards: 'Recompensas Exclusivas',
		tipHigherRakeback: 'Cashback Maior',
		tipPrioritySupport: 'Suporte Prioritário',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'Nível',
		tableRequiredXp: 'EXP necessária',
		tableLevelUpBonus: 'Bônus de subida de nível',
		tableDailyRakeback: 'Cashback diário',
		tableWeeklyLossback: 'Reembolso semanal',
		signIn: 'Entrar',
		vipClubDefaultDesc: 'Junte-se ao nosso VIP Club agora e prepare-se para receber presentes, sorteios e recursos incríveis.',
	},
};
